module.exports = __webpack_public_path__ + "img/tryBg.3c3d7f4.png";